import { Link } from "react-router-dom";
import { BrandLockup } from "@/shell/CandidateFlow";
import { RecruiterShell } from "@/shell/RecruiterShell";

const T = { ink: "#17131F", accent: "var(--accent)", slate: "#7C7590", white: "#FFFFFF" };

const features = [
  { title: "Your brand, your portal", body: "Add your logo and brand colours. Candidates see your brand, not ours." },
  { title: "AI-powered practice interviews", body: "Send a link. Candidates practise with exec-level personas — CMO, Founder, Hiring Manager." },
  { title: "Candidate scorecards", body: "Review how each candidate performed across structure, delivery, and executive presence." },
  { title: "Manage all your candidates", body: "Track every session, scorecard, and transcript from one dashboard." },
];

export function OnboardingWelcome() {
  return (
    <RecruiterShell activeNav="home">
      <div style={{ textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>
          <BrandLockup />
        </div>
        <h1 style={{ margin: "10px 0 8px", fontSize: 28, fontWeight: 700, color: T.ink, lineHeight: 1.2 }}>
          Welcome aboard
        </h1>
        <p style={{ margin: 0, fontSize: 14, color: T.slate }}>
          Your candidate preparation portal is ready to set up. Takes about 2 minutes.
        </p>
      </div>

      <div style={{ display: "flex", justifyContent: "center", padding: "32px 0 8px" }}>
        <div style={{ width: "100%", maxWidth: 440, background: T.white, borderRadius: 16,
          boxShadow: "0 24px 64px rgba(27,26,36,0.10), 0 4px 12px rgba(27,26,36,0.06)", padding: "32px 28px" }}>

          <div style={{ display: "flex", flexDirection: "column", gap: 16, marginBottom: 28 }}>
            {features.map((f) => (
              <div key={f.title} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <span style={{ color: T.accent, fontWeight: 700, fontSize: 16, marginTop: 1, flexShrink: 0 }}>✦</span>
                <div>
                  <p style={{ margin: "0 0 2px", fontSize: 13, fontWeight: 600, color: T.ink }}>{f.title}</p>
                  <p style={{ margin: 0, fontSize: 13, color: T.slate, lineHeight: 1.5 }}>{f.body}</p>
                </div>
              </div>
            ))}
          </div>

          <Link
            to="/agency/brand-setup?onboarding=1"
            style={{ display: "block", width: "100%", padding: "13px 0", textAlign: "center",
              fontSize: 15, fontWeight: 600, color: T.white, background: T.accent,
              borderRadius: 8, textDecoration: "none", boxSizing: "border-box" }}>
            Get started →
          </Link>
        </div>
      </div>
    </RecruiterShell>
  );
}
